// Provee el access token de Auth0 a la capa de helpers.
//
// `helpers/fetch.js` es una función suelta, no un componente, asi que no puede
// usar el hook `useAuth0()` de `@auth0/auth0-react` para pedir el token. Este
// modulo guarda la funcion que quedo registrada desde adentro del provider
// (ver `App.js`), y los helpers la invocan.
//
// Importante: el registro se hace **durante el render** de `App`, no en un
// `useEffect`. En React los efectos de los hijos corren antes que los del padre,
// y los thunks que disparan los `useEffect` de `costingRouter` corren antes que
// un `useEffect` de `App`: con un `useEffect` el primer lote de requests sale sin
// token y la app queda en blanco.

// Audience de la API en Auth0. Es un identificador PUBLICO (viaja dentro del token
// que el navegador ya tiene) y es el mismo en dev, QAS y produccion: hay una sola
// API registrada en el tenant para los tres ambientes, a proposito, para no tener
// un audience distinto por entorno.
//
// Va hardcodeado y no como `REACT_APP_*` a proposito: una variable de build
// faltante NO rompe el build de CRA, compila igual y se publica, y el fallo aparece
// en runtime. Ese es el modo de falla documentado en `AGENTS.md`. Hardcodeado hay
// una sola fuente de verdad y no se puede olvidar en un deploy.
export const AUTH0_AUDIENCE = 'https://ccobac.seidoranalytics.com/api';

let tokenProvider = null;

// La funcion se re-registra en cada render de `App` porque la identidad de
// `getAccessTokenSilently` puede cambiar; el registro es idempotente.
export function registerTokenProvider(provider) {
    tokenProvider = provider;
}

export function clearTokenProvider() {
    tokenProvider = null;
}

export async function getAccessToken() {
    if (!tokenProvider) {
        throw new Error(
            'No hay proveedor de token de Auth0 registrado. Suele significar que un helper ' +
            'se está usando fuera del Auth0Provider.'
        );
    }
    // `getAccessTokenSilently` cachea el token en el SDK y refresca solo cuando va a
    // expirar, asi que no hay que memoizar nada aca.
    return tokenProvider();
}
